import { HandleAuthFailureCommand } from './handle-auth-failure.command';
import { HandleAuthSuccessCommand } from './handle-auth-success.command';
import { LogoutCommand } from './logout.command';
import { SwitchTenantCommand } from './switch-tenant.command';

export * from './handle-auth-failure.command';
export * from './handle-auth-success.command';
export * from './logout.command';
export * from './switch-tenant.command';

export const SecurityCommandServices = [
    HandleAuthFailureCommand,
    HandleAuthSuccessCommand,
    LogoutCommand,
    SwitchTenantCommand,
];
